import React, { useState } from 'react'

export const ErrorContext = React.createContext()

export const WithErrorContext = (Component) => (props) => (
    <ErrorContext.Consumer>
        {(errorContext) => <Component errorContext={errorContext} {...props} />}
    </ErrorContext.Consumer>
)

export function ErrorProvider(props) {
    const [currentErrorMessage, setCurrentErrorMessage] = useState(null)

    const messageList = []
    function pushErrorMessage({
        errorKey,
        replaceArgs = {},
        action1 = () => {},
        action2 = () => {},
    }) {
        const timestap = Date.now()
        if (currentErrorMessage === null) {
            setCurrentErrorMessage({
                timestap,
                errorKey,
                replaceArgs,
                action1,
                action2,
            })
        } else {
            messageList.push({
                timestap,
                errorKey,
                replaceArgs,
                action1,
                action2,
            })
        }
    }

    function closeCurrentErrorMessage() {
        if (messageList.length === 0) {
            setCurrentErrorMessage(null)
        } else {
            setCurrentErrorMessage(messageList.shift())
        }
    }

    return (
        <ErrorContext.Provider
            value={{
                currentErrorMessage,
                pushErrorMessage,
                closeCurrentErrorMessage,
            }}
        >
            {props.children}
        </ErrorContext.Provider>
    )
}
